import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-700 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-900">
                <i className="ri-leaf-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">妖精动漫网</span>
            </div>
            <p className="text-sm leading-6 text-background-200/90 max-w-xs">
              专注妖精 / 精灵类动漫的角色百科与声优表，让每一位爱好者都能快速查角色、看作品、找声优。
            </p>
          </div>

          {/* 栏目导航 */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">栏目导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200/90 hover:text-accent-300 transition-colors">首页</Link></li>
              <li><Link to="/characters" className="text-background-200/90 hover:text-accent-300 transition-colors">角色百科</Link></li>
              <li><Link to="/seiyuu" className="text-background-200/90 hover:text-accent-300 transition-colors">声优表</Link></li>
              <li><Link to="/works" className="text-background-200/90 hover:text-accent-300 transition-colors">作品专题</Link></li>
              <li><Link to="/about" className="text-background-200/90 hover:text-accent-300 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          {/* 热门分类 */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/characters?c=forest-elf" className="text-background-200/90 hover:text-accent-300 transition-colors">森林精灵</Link></li>
              <li><Link to="/characters?c=flower-fairy" className="text-background-200/90 hover:text-accent-300 transition-colors">花之妖精</Link></li>
              <li><Link to="/characters?c=star-spirit" className="text-background-200/90 hover:text-accent-300 transition-colors">星之精灵</Link></li>
              <li><Link to="/characters?c=elemental" className="text-background-200/90 hover:text-accent-300 transition-colors">元素精灵</Link></li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-200/90">
              <li className="flex items-center gap-2"><i className="ri-mail-line" /> hi@yaojing-anime.example</li>
              <li className="flex items-center gap-2"><i className="ri-time-line" /> 内容更新 · 每周同步</li>
              <li className="flex items-center gap-2"><i className="ri-question-line" /> <Link to="/about" className="hover:text-accent-300 transition-colors">常见问题与意见反馈</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 hover:bg-accent-500 hover:text-primary-900 transition-colors cursor-pointer"><i className="ri-weibo-line" /></span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 hover:bg-accent-500 hover:text-primary-900 transition-colors cursor-pointer"><i className="ri-bilibili-line" /></span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 hover:bg-accent-500 hover:text-primary-900 transition-colors cursor-pointer"><i className="ri-message-3-line" /></span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-600 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/70">
          <p>© 2026 妖精动漫网 · 专注妖精动漫角色百科与声优表</p>
          <p className="flex items-center gap-1.5">
            让每一份热爱都有迹可循
            <i className="ri-heart-line text-accent-400" />
          </p>
        </div>
      </div>
    </footer>
  );
}